export const ERROR_CODES = {
  FAILED_TO_FETCH_ACCESS_TOKEN: "FAILED_TO_FETCH_ACCESS_TOKEN",
  FAILED_TO_FETCH_ORDER: "FAILED_TO_FETCH_ORDER",
  FAILED_TO_FETCH_OPERATORS: "FAILED_TO_FETCH_OPERATORS",
  FAILED_TO_CREATE_SETUP_INTENT: "FAILED_TO_CREATE_SETUP_INTENT",
  FAILED_TO_SET_PAYMENT_METHOD: "FAILED_TO_SET_PAYMENT_METHOD",
  FAILED_TO_CREATE_ORDER: "FAILED_TO_CREATE_ORDER",
  FAILED_TO_ADD_TO_CART: "FAILED_TO_ADD_TO_CART",
  FAILED_TO_INITIATE_BANKID: "FAILED_TO_INITIATE_BANKID",
  FAILED_TO_VERIFY_BANKID: "FAILED_TO_VERIFY_BANKID",
  BANKID_USER_CANCELLED: "BANKID_USER_CANCELLED",
  BANKID_SESSION_EXPIRED: "BANKID_SESSION_EXPIRED",
  BANKID_UNAUTHORIZED: "BANKID_UNAUTHORIZED",
  FAILED_TO_UPDATE_ORDER: "FAILED_TO_UPDATE_ORDER",
  // Backend payment error codes (structured response from API)
  CARD_DECLINED: "CARD_DECLINED",
  INSUFFICIENT_FUNDS: "INSUFFICIENT_FUNDS",
  AUTHENTICATION_REQUIRED: "AUTHENTICATION_REQUIRED",
  INVALID_CARD: "INVALID_CARD",
  PAYMENT_METHOD_REJECTED: "PAYMENT_METHOD_REJECTED",
  CREDIT_CHECK_DENIED: "CREDIT_CHECK_DENIED",
  RATE_LIMITED: "RATE_LIMITED",
  PAYMENT_PROVIDER_ERROR: "PAYMENT_PROVIDER_ERROR",
  STRIPE_ERROR: "STRIPE_ERROR",
  CARD_EXPIRED: "CARD_EXPIRED",
  CARD_LOST_OR_STOLEN: "CARD_LOST_OR_STOLEN",
  CIRCULY_RATE_LIMIT: "CIRCULY_RATE_LIMIT",
  CIRCULY_SERVICE_ERROR: "CIRCULY_SERVICE_ERROR",
  COMMERCE_LAYER_ERROR: "COMMERCE_LAYER_ERROR",
  INVALID_ORDER_DATA: "INVALID_ORDER_DATA",
  ORDER_NOT_FOUND: "ORDER_NOT_FOUND",
  UNKNOWN: "UNKNOWN",
} as const;

// Create a type from our error codes
export type ErrorCode = (typeof ERROR_CODES)[keyof typeof ERROR_CODES];

// Helper function to check if a string is an error code
export function isErrorCode(code: string): code is ErrorCode {
  return Object.values(ERROR_CODES).includes(code as ErrorCode);
}
